export default "__VITE_ASSET__BuzkYBsI__"